'use strict';

const ExternalDeal = {
  init({ externalDeal }, done) {
    if (!externalDeal) {
      return done();
    }

    const $externalBuyButton = document.querySelectorAll('.external-buy');
    $externalBuyButton.forEach(el =>
      el.addEventListener('click', e => {
        e.preventDefault();
        window.open(el.getAttribute('href'));
        return setTimeout(window.GIG.Modal.close, 3000);
      })
    );

    return done();
  },
};

module.exports = ExternalDeal;
